import { render, staticRenderFns } from "./query-orders.vue?vue&type=template&id=edcc6eaa&"
import script from "./query-orders.vue?vue&type=script&lang=js&"
export * from "./query-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports